import React from 'react'
import { CustomText } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { UserSaleOffer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'
import styles from './SaleOfferTotalColumn.module.scss'

const SaleOfferTotalColumn: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === offer.currency)?.code
  const priceLabel = `${getFormatedPrice(offer.total, currencyCode)}`

  return <div className={styles.content}>
    <CustomText label={priceLabel} />
    {(offer.show_discount && offer.discount) &&  <>
      <CustomText label={`${offer.discount}%`} mark/>
    </>}
  </div>
}

export default SaleOfferTotalColumn
